import { gql } from '@apollo/client';

export const WEB_NOVEL_CHAPTER_DTO = gql`
  fragment WebNovelChapterDto on Chapter {
    storyId
    chapterId
    chapterIndex
    name
    adsOn
    freedAt
    price
    currentPlayingStatus
    isAdult
    userPurchasedChapter {
      usedAmount
    }
  }
`;
